import { useCallback } from 'react';

/** A hook that can be used as the callback to a TextField.onChange event. */
export function useTextChangeCallback(setValue: (value: string) => void) {
    return useCallback((_: unknown, value?: string) => setValue(value || ''), [setValue]);
}
